import { render, staticRenderFns } from "./telephone.vue?vue&type=template&id=dd394f28&scoped=true"
import script from "./telephone.vue?vue&type=script&lang=js"
export * from "./telephone.vue?vue&type=script&lang=js"
import style0 from "./telephone.vue?vue&type=style&index=0&id=dd394f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd394f28",
  null
  
)

export default component.exports